import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { DIMENSION_CORRECTION_MODULE } from '../../Constants';

/**
 * モジュール変更確認ダイアログ
 * 変更時には、寸法モード（フリー寸法/モジュール補正）とモジュールピッチの反映、寸法線の再描画を行う
 * ※住宅設備・家具・エクステリアは削除しない（位置がずれる場合はあるが、そのまま残す方針）
 */
class ConfirmChangeModuleDialog extends Dialog {
    public targetModule: number;

    // 反映する寸法補正コード（0: フリー寸法 / 1: モジュール補正）。既定はモジュール補正。
    public targetDimensionCorrection: number = DIMENSION_CORRECTION_MODULE;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'confirmChangeModuleDialog';
      const title = '';

      let contents = '<div class="confirmChangeModuleDialog" style="width:500px">\n';
      contents += '<span class="jp">モジュールを変更すると、配置されている住宅設備・家具・エクステリアの位置がずれる場合があります。よろしいですか？</span><span class="en">Equipment, furniture, and exterior items may be shifted when changing the module pitch. Would you like to proceed?</span>';
      contents += '</div>\n';

      let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
      footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

      // ヘッダーの×ボタンの削除
      this.showHeaderCloseButton = false;

      this.createDialog(id, title, contents, footer);

      this.viewObj.querySelectorAll('button').forEach((element) => {
        element.addEventListener('click', this.btnEventHandler);
      });
    }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      e.preventDefault();

      if (e.currentTarget.value === 'true') {
        // ピッチ変更前の値を保持（住宅設備・家具・エクステリアのサイズ拡縮率の算出用）
        const prevModulePitch: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;

        // 寸法モード（フリー寸法/モジュール補正）とモジュールピッチを反映
        marietta.webcad.WebCADGlobal.moduleManager.dimensionCorrection = this.targetDimensionCorrection;
        marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch = this.targetModule;
        // モジュール補正で確定したピッチは「モジュール補正選択時の初期値」として記憶する
        // （フリー寸法↔モジュール補正の切替時に直近の入力値を復元するため）
        if (this.targetDimensionCorrection === DIMENSION_CORRECTION_MODULE) {
          marietta.webcad.WebCADGlobal.moduleManager.modulePitchFromApp = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
        }

        // 住宅設備・家具・エクステリアは削除しない（位置がずれる場合はあるが、そのまま残す方針）
        // 実寸(mm)を新旧ピッチの比率で拡大縮小する（例: 900→1800なら実寸も2倍）
        const pitchRatio: number = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch / prevModulePitch;
        marietta.webcad.WebCADGlobal.itemManager.resizeModuleEffectItems(pitchRatio);

        // 部屋のサイズ更新
        marietta.webcad.WebCADGlobal.itemManager.updateRoomSizeTexts();
        // 部屋の内側寸法は生成時のピッチで固定されるため、ここで新ピッチへ再計算する
        marietta.webcad.WebCADGlobal.itemManager.updateRoomWallGuides();

        marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine(true);

        //見積一覧を更新する
        marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
      }
      // モジュール選択UI（コンボボックス表示・スナップ欄）を現在の寸法モードへ同期する。
      // ※「いいえ」時も現在値へ戻す役割を兼ねる。snapUnit は初期化しない。
      marietta.webcad.WebCADGlobal.webcad2Dmanager.refreshModuleUiForMode();

      this.close();
    }
}

export default ConfirmChangeModuleDialog;
